import type { RootState } from '@/app/store';
import Title from '@/components/ui/Title';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResourcesSection from '@/components/pages/webinars/resources/ResourcesSection';
import ProgramSection from '@/components/pages/webinars/program/ProgramSection';

type WebinarsTab = 'program' | 'resources';

// État de navigation pour ouvrir un onglet précis (ex. retour sur la programmation après publication).
export const PROGRAM_TAB_STATE = { tab: 'program' } as const satisfies { tab: WebinarsTab };

export default function WebinarsPage() {
  const { t } = useTranslation('webinars');
  const currentWorkspace = useSelector((state: RootState) => state.workspace.currentWorkspace);
  const requestedTab = (useLocation().state as { tab?: WebinarsTab } | null)?.tab;

  const defaultTab =
    requestedTab ?? (currentWorkspace?.visualIdentity?.modified ? 'program' : 'resources');

  return (
    <div className="space-y-8">
      <Title level={1}>{t('title')}</Title>

      <Tabs defaultValue={defaultTab}>
        <TabsList className="w-full pb-12">
          <TabsTrigger value="program">
            <Title level={3}>{t('tabs.programmation')}</Title>
          </TabsTrigger>
          <TabsTrigger value="resources">
            <Title level={3}>{t('tabs.resources')}</Title>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="program">
          <ProgramSection />
        </TabsContent>
        <TabsContent value="resources">
          <ResourcesSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
